import {Injectable} from '@angular/core';
import {CronJobsConfig, CronJobsSelectOption, CronJobsValidationConfig, OptionType} from '../contracts';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class DataService {

  private defaultConfig: CronJobsConfig = {
    quartz: false,
    bootstrap: true,
    multiple: false,
  };

  private defaultValidateConfig: CronJobsValidationConfig = {
    validate: false,
  };

  private daysOfWeekPosix: Array<CronJobsSelectOption> = [
      {value: 0, label: this.t.instant('components.cron.days.Su')},
      {value: 1, label: this.t.instant('components.cron.days.Mo')},
      {value: 2, label: this.t.instant('components.cron.days.Tu')},
      {value: 3, label: this.t.instant('components.cron.days.We')},
      {value: 4, label: this.t.instant('components.cron.days.Th')},
      {value: 5, label: this.t.instant('components.cron.days.Fr')},
      {value: 6, label: this.t.instant('components.cron.days.Sa')}
  ];

  private daysOfWeekQuartz: Array<CronJobsSelectOption> = [
      {value: 1, label: this.t.instant('components.cron.days.Su')},
      {value: 2, label: this.t.instant('components.cron.days.Mo')},
      {value: 3, label: this.t.instant('components.cron.days.Tu')},
      {value: 4, label: this.t.instant('components.cron.days.We')},
      {value: 5, label: this.t.instant('components.cron.days.Th')},
      {value: 6, label: this.t.instant('components.cron.days.Fr')},
      {value: 7, label: this.t.instant('components.cron.days.Sa')}
  ];

  private numeral: Array<CronJobsSelectOption> = [
      {value: 1, label: this.t.instant('components.cron.numeral.1st')},
      {value: 2, label: this.t.instant('components.cron.numeral.2nd')},
      {value: 3, label: this.t.instant('components.cron.numeral.3rd')},
      {value: 4, label: this.t.instant('components.cron.numeral.4th')},
      {value: 5, label: this.t.instant('components.cron.numeral.5th')},
      {value: 6, label: this.t.instant('components.cron.numeral.6th')},
      {value: 7, label: this.t.instant('components.cron.numeral.7th')},
      {value: 8, label: this.t.instant('components.cron.numeral.8th')},
      {value: 9, label: this.t.instant('components.cron.numeral.9th')},
      {value: 10, label: this.t.instant('components.cron.numeral.10th')},
      {value: 11, label: this.t.instant('components.cron.numeral.11th')},
      {value: 12, label: this.t.instant('components.cron.numeral.12th')},
      {value: 13, label: this.t.instant('components.cron.numeral.13th')},
      {value: 14, label: this.t.instant('components.cron.numeral.14th')},
      {value: 15, label: this.t.instant('components.cron.numeral.15th')},
      {value: 16, label: this.t.instant('components.cron.numeral.16th')},
      {value: 17, label: this.t.instant('components.cron.numeral.17th')},
      {value: 18, label: this.t.instant('components.cron.numeral.18th')},
      {value: 19, label: this.t.instant('components.cron.numeral.19th')},
      {value: 20, label: this.t.instant('components.cron.numeral.20th')},
      {value: 21, label: this.t.instant('components.cron.numeral.21st')},
      {value: 22, label: this.t.instant('components.cron.numeral.22nd')},
      {value: 23, label: this.t.instant('components.cron.numeral.23rd')},
      {value: 24, label: this.t.instant('components.cron.numeral.24th')},
      {value: 25, label: this.t.instant('components.cron.numeral.25th')},
      {value: 26, label: this.t.instant('components.cron.numeral.26th')},
      {value: 27, label: this.t.instant('components.cron.numeral.27th')},
      {value: 28, label: this.t.instant('components.cron.numeral.28th')},
      {value: 29, label: this.t.instant('components.cron.numeral.29th')},
      {value: 30, label: this.t.instant('components.cron.numeral.30th')},
      {value: 31, label: this.t.instant('components.cron.numeral.31st')}
  ];

  private _months: Array<CronJobsSelectOption> = [
      {value: 1, label: this.t.instant('components.cron.month.Jan')},
      {value: 2, label: this.t.instant('components.cron.month.Feb')},
      {value: 3, label: this.t.instant('components.cron.month.Mar')},
      {value: 4, label: this.t.instant('components.cron.month.Apr')},
      {value: 5, label: this.t.instant('components.cron.month.May')},
      {value: 6, label: this.t.instant('components.cron.month.Jun')},
      {value: 7, label: this.t.instant('components.cron.month.Jul')},
      {value: 8, label: this.t.instant('components.cron.month.Aug')},
      {value: 9, label: this.t.instant('components.cron.month.Sep')},
      {value: 10, label: this.t.instant('components.cron.month.Oct')},
      {value: 11, label: this.t.instant('components.cron.month.Nov')},
      {value: 12, label: this.t.instant('components.cron.month.Dec')}
  ];

    private _baseFrequency: Array<CronJobsSelectOption> = [
        {value: 0, label: this.t.instant('common.please-select')},
        {value: 1, type: OptionType.minute, label: this.t.instant('components.cron.frequency.Mi')},
        {value: 2, type: OptionType.hour, label: this.t.instant('components.cron.frequency.Ho')},
        {value: 3, type: OptionType.day, label: this.t.instant('components.cron.frequency.Da')},
        {value: 4, type: OptionType.week, label: this.t.instant('components.cron.frequency.We')},
        {value: 5, type: OptionType.month, label: this.t.instant('components.cron.frequency.Mo')},
        {value: 6, type: OptionType.year, label: this.t.instant('components.cron.frequency.Ye')}
    ];

    private _hours: Array<CronJobsSelectOption>;
    private _minutes: Array<CronJobsSelectOption>;


    public get baseFrequency(): Array<CronJobsSelectOption> {
        return [
            ...this._baseFrequency
        ];
    }

    public get daysOfMonth(): Array<CronJobsSelectOption> {
        return [
            ...this.numeral
        ];
    }

    public get months(): Array<CronJobsSelectOption> {
        return [
            ...this._months
        ];
    }

    public get hours(): Array<CronJobsSelectOption> {
        return [
            ...this._hours
        ];
    }

    public get minutes(): Array<CronJobsSelectOption> {
        return [
            ...this._minutes
        ];
    }

    constructor(private t: TranslateService) {
        this._hours = [];
        for (let x = 0; x < 24; x++) {
            this._hours.push(<CronJobsSelectOption> {value: x, label: `${x}`});
        }

        this._minutes = [];
        for (let x = 0; x < 60; x = x + 5) {
            this._minutes.push(<CronJobsSelectOption> {value: x, label: `${x}`});
        }

    }


    getConfig(config: CronJobsConfig = {}): CronJobsConfig {
        return {
            ...this.defaultConfig,
            ...config
        };
    }

    getValidate(validateConfig: CronJobsValidationConfig = {}): CronJobsValidationConfig {
        return {
            ...this.defaultValidateConfig,
            ...validateConfig
        };
    }

    getDaysOfWeek(quartz: Boolean = false): Array<CronJobsSelectOption> {
        if (quartz) {
            return [
                ...this.daysOfWeekQuartz
            ];
        }
        return [
            ...this.daysOfWeekPosix
        ];
    }

    private fake() {
        let text = '';
        let authority = 'ROLE_ADMIN';
        [
            'WRITE_API',
            'WRITE_AUDITS',
            'WRITE_CONFIGURATION',
            'WRITE_DATASTORE',
            'WRITE_DATAVIEWS',
            'WRITE_EMAIL_TRANSACTIONAL',
            'WRITE_HTML_BLOCK',
            'WRITE_HTML5_TEMPLATE',
            'WRITE_IMPORTS',
            'WRITE_INVOICE_CONTACTS',
            'WRITE_LANDING_PAGE_CONFIGURATION',
            'WRITE_LOGS',
            'WRITE_MAINTENANCE',
            'WRITE_METRICS',
            'WRITE_ORDERS',
            'WRITE_PROVIDERS',
            'WRITE_SUBSCRIPTIONS',
            'WRITE_TABLES',
            'WRITE_USERS',
            'WRITE_USERS_TRACKING'
        ].forEach(rule => {
            text += `
            <insert schemaName="uaa" tableName="authority_rule">
                <column name="authority" value="${authority}" />
                <column name="rule" value="${authority}" />
		    </insert>`;
        });
    }

}
